import { render, staticRenderFns } from "./HistoryContent.vue?vue&type=template&id=def04516&scoped=true&"
import script from "./HistoryContent.vue?vue&type=script&lang=js&"
export * from "./HistoryContent.vue?vue&type=script&lang=js&"
import style0 from "../../../less/history.less?vue&type=style&index=0&id=def04516&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "def04516",
  null
  
)

export default component.exports